import script from "./Test.vue?vue&type=script&setup=true&lang=ts"
export * from "./Test.vue?vue&type=script&setup=true&lang=ts"

import "./Test.vue?vue&type=style&index=0&id=3c0c6cbe&scoped=true&lang=less"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3c0c6cbe"]])

export default __exports__